import {useQuery} from "@tanstack/react-query";
import axiosManager from "../services/axiosManager";
import {sortLanguages} from "../utils/languagesHelpers";

export const useGetLanguages = () => {
    const {
        isFetching: isLoading, data: languages, error,
    } = useQuery({
        queryKey: ["languages"],
        queryFn: () => axiosManager.get$("languages").then((response) => response?.data),
        initialData: [],
        retry: 0,
    });

    const languagesOptions = sortLanguages((languages || []).map((item) => ({value: item.languageCode, label: item.name})));

    return {
        isLoading, languages, error, languagesOptions,
    };

};
